module.exports = __webpack_public_path__ + "img/footer_logo.b0ca881.png";